var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEigentmerwechsel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62.5 65.3",
    style: {
      enableBackground: "new 0 0 62.5 65.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.8,37.7c-0.3,0-0.7,0-0.9,0.2c-0.3,0.2-0.4,0.5-0.5,0.8C55.8,50.4,46,58.3,32.4,59c-13.4,0.7-25-8.9-27-22 l0.2,0.2c0.2,0.4,0.7,0.6,1.1,0.6c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.5-0.5,0.5-0.8c0.1-0.3,0-0.7-0.2-0.9l-2.7-4.2 c-0.2-0.4-0.7-0.6-1.1-0.6s-0.8,0.3-1,0.7l-2.3,4.4c-0.3,0.6-0.1,1.4,0.5,1.7c0.6,0.3,1.4,0.1,1.7-0.5L2.9,37 c1.9,14.1,14,24.6,28.2,24.6c0.5,0,1,0,1.5,0c14.6-0.8,25.5-9.7,27.2-22.4C59.9,38.4,59.4,37.8,58.8,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.5,27.4L61.5,27.4c-0.6-0.3-1.3-0.1-1.7,0.5l-0.2,0.3c-1.2-14.6-13.5-26-28.4-26c-13.7,0-25.4,9.7-28,23.1 c-0.1,0.7,0.3,1.3,1,1.4s1.3-0.3,1.4-1C8,13.5,18.8,4.6,31.2,4.6c13.4,0,24.6,10.2,25.9,23.5L57,27.9c-0.3-0.6-1.1-0.8-1.7-0.5 c-0.6,0.3-0.8,1.1-0.5,1.7l2.5,4.3c0.2,0.4,0.6,0.6,1.1,0.6s0.9-0.2,1.1-0.6l2.5-4.3C62.3,28.5,62.1,27.7,61.5,27.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.7,42H23.9V31.7h14.3c0.6,0,1.1-0.1,1.4-0.4c0.2-0.2,0.4-0.5,0.4-0.9c0-0.5-0.2-0.7-0.3-0.9 c-0.3-0.2-0.7-0.3-1.4-0.3H23.9V20h15.4c0.7,0,1.2-0.1,1.4-0.4c0.3-0.2,0.4-0.5,0.4-0.9c0-0.4-0.1-0.7-0.4-0.9 c-0.3-0.2-0.8-0.4-1.4-0.4H23.6c-0.7,0-1.2,0.1-1.7,0.3c-0.3,0.1-0.5,0.4-0.7,0.7c-0.2,0.4-0.3,1-0.3,1.7v22.1c0,1,0.2,1.7,0.6,2.1 c0.4,0.4,1.1,0.6,2.1,0.6h16.2c0.7,0,1.2-0.1,1.4-0.4c0.3-0.2,0.4-0.5,0.4-1c0-0.6-0.2-0.8-0.4-1C40.9,42.2,40.4,42,39.7,42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEigentmerwechsel);
export default __webpack_public_path__ + "static/media/Eigentümerwechsel.bac8c4efd97af26178d0f68e11702ce4.svg";
export { ForwardRef as ReactComponent };